import history from 'utils/history'

export default function redirectTo(path: string, next?: string, replaceHistory = false) {
  const url = path + (next ? `?next=${next}` : '')
  replaceHistory ? (window.location.href = url) : history.push(url)
}
